//this file will contain all google tag manager scripts

class Gtm {

  /**
   * When search form changes, go throught all the form data and compare it to the changed data and pick all the new key value pairs and push them to the dataLayer
   *
   * @memberof Gtm
   */
  vehicleSearchEvents() {
    const vehicleSearchForm = document.querySelector('.vehicle-search-filters__form');
    if(!vehicleSearchForm) return;

    let formData = this._getFormData(vehicleSearchForm);
    let formString = JSON.stringify(formData);
    const advancedFilters = [...vehicleSearchForm.querySelectorAll('.vehicle-search-filters__additional-filters input, .vehicle-search-filters__additional-filters select')].map(input => input.name);

    vehicleSearchForm.addEventListener('change', e => {
      try {
        const newFormData = this._getFormData(vehicleSearchForm);
        const newFormString = JSON.stringify(newFormData);

        if(formString !== newFormString) {

          const changedData = Object.keys(newFormData).reduce((diff, key) => {
            if (formData[key] === newFormData[key]) return diff
            if((Array.isArray(formData[key]) && Array.isArray(newFormData[key])) && (formData[key].sort().toString() === newFormData[key].sort().toString())) return diff;
            return {
              ...diff,
              [key]: newFormData[key]
            }
          }, {});

          Object.entries(changedData).forEach(([key, value]) => {
            const advancedFilter = advancedFilters.includes(key);
            window.dataLayer.push({
              'event': 'GAEvent',
              'eventCategory': `Car search - ${advancedFilter ? 'extended' : 'simple'}`,
              'eventAction': 'Search',
              'eventLabel': `${key.replace('[]','')}: ${value}`, //replace key [] in event label
            });
          });

          formString = newFormString;
          formData = newFormData;
        }
      } catch(e) {
        console.log(e);
      }

    });
  }

  /**
   * get form data from for elemen and return it as key value pairs where value is not falsy
   *
   * @param {*} formElement form element
   * @return {*}
   * @memberof Gtm
   */
  _getFormData(formElement) {
    const formData = new FormData(formElement);

    const fData = {};

    for (let key of formData.keys()) {
      const values = formData.getAll(key).filter(Boolean);
      if(values.length) {
        fData[key] = values.length === 1 ? values[0] : values;
      }
    }

    return fData;
  }

  init() {
    window.dataLayer = window.dataLayer || []; //if no datalayer found, create one
    this.vehicleSearchEvents();
  }
}

export default new Gtm;
